import { getRootDomain } from '../utils/domain';

export const COOKIE_KEY = {
  USER_ID: 'user_id',
  AUTH_TOKEN: 'auth_token',
  DEVICE_ID: 'device_id',
  UUID: 'uuid',
  REFRESH_TOKEN: 'refresh_token',
  IS_NEW: 'is_new',
  IS_ANONYMOUS: 'is_anonymous',
  UNIQUE_ID: 'unique_id',
};

// 前端自定义 cookie 列表
export const CUSTOM_COOKIE_LIST = [COOKIE_KEY.UUID];
export const COOKIE_EXPIRE_TIME = 1000 * 60 * 60 * 24 * 7; // 7天

export const ROOT_COOKIE_KEY = {
  ROOT_AUTH_TOKEN: 'root_auth_token',
  ROOT_DEVICE_ID: 'root_device_id',
  ROOT_UUID: 'root_uuid',
  ROOT_USER_ID: 'root_user_id',
  ROOT_REFRESH_TOKEN: 'root_refresh_token',
  ROOT_IS_NEW: 'root_is_new',
  ROOT_IS_ANONYMOUS: 'root_is_anonymous',
  ROOT_UNIQUE_ID: 'root_unique_id',
};

export const ROOT_IM_COOKIE_KEY = 'root_im_account_info';
export const ROOT_DISABLE_FIREBASE_COOKIE_KEY = 'root_disable_firebase';

export const getCommonCookieOptions = (host?: string) => {
  const rootDomain = getRootDomain(host);
  return {
    maxAge: COOKIE_EXPIRE_TIME,
    httpOnly: true,
    domain: rootDomain,
    path: '/',
  };
};

export const getExpireCookieOptions = (host?: string) => {
  const rootDomain = getRootDomain(host);
  return {
    maxAge: -1,
    httpOnly: true,
    domain: rootDomain,
    path: '/',
  };
};

export function getCookie(name: string): string | null {
  const nameEQ = name + '=';
  const cookies = document.cookie.split(';');

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.indexOf(nameEQ) === 0) {
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }

  return null;
}
